import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [
    {
        name: 'editEventEmail',
        url: '/editEventEmail',
        component: 'wtEditEventEmailState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer])
        },
        params: {
            'item':null
        },
        data: {
            sortingOrder: -1,
            icon: '',
            displayName: 'Edit Email',
            editRoles: [Roles.administrator, Roles.master, Roles.engineer],
            editButtonVisibility: () => true,
            editButtonDisabled: () => true
        }
    }];

export default states;